// Landing Page Themes Index
export { default as ModernTheme } from './ModernTheme';
export { default as ClassicTheme } from './ClassicTheme';
export { default as VibrantTheme } from './VibrantTheme';
export { default as MinimalTheme } from './MinimalTheme';
export { default as ProfessionalTheme } from './ProfessionalTheme';

// Theme metadata for selection UI
export const THEMES = {
  modern: {
    id: 'modern',
    name: 'Modern',
    description: 'Clean, minimal design with card-based layout',
    preview: '/placeholders/theme-modern.png',
  },
  classic: {
    id: 'classic',
    name: 'Classic',
    description: 'Traditional, warm design with serif fonts',
    preview: '/placeholders/theme-classic.png',
  },
  vibrant: {
    id: 'vibrant',
    name: 'Vibrant',
    description: 'Bold colors with gradients and animations',
    preview: '/placeholders/theme-vibrant.png',
  },
  minimal: {
    id: 'minimal',
    name: 'Minimal',
    description: 'Ultra-simple with lots of whitespace',
    preview: '/placeholders/theme-minimal.png',
  },
  professional: {
    id: 'professional',
    name: 'Professional',
    description: 'Corporate feel with structured layout',
    preview: '/placeholders/theme-professional.png',
  },
};

// Get theme component by name
export const getThemeComponent = (themeName) => {
  const themes = {
    modern: require('./ModernTheme').default,
    classic: require('./ClassicTheme').default,
    vibrant: require('./VibrantTheme').default,
    minimal: require('./MinimalTheme').default,
    professional: require('./ProfessionalTheme').default,
  };
  return themes[themeName] || themes.modern;
};
